import { render } from "./AlertasFeedbackNew.vue?vue&type=template&id=dca1f8ac&scoped=true"
import script from "./AlertasFeedbackNew.vue?vue&type=script&lang=js"
export * from "./AlertasFeedbackNew.vue?vue&type=script&lang=js"

import "./AlertasFeedbackNew.vue?vue&type=style&index=0&id=dca1f8ac&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dca1f8ac"]])

export default __exports__